// extracted by mini-css-extract-plugin
export default {"unAuthorizedHeading":"not-found_unAuthorizedHeading__lJ8an","unAuthorizedParagraph":"not-found_unAuthorizedParagraph__PjadV"};